import { useContext, useEffect } from "react";

import classnames from "classnames";

import { Rating } from "components/pages/checkout/components/Rating";
import { BrandSegmentBadge } from "components/pages/search/components/BrandSegmentBadge";
import { PropertyListingContext, useBootstrap } from "components/store/source";
import { Header, Section, Text } from "components/ui/source";

import TopAmenities from "../Building/TopAmenities/TopAmenities";
import TopStandards from "../Building/TopStandards/TopStandards";
import TopUpgrades from "../Building/TopUpgrades/TopUpgrades";

import Features from "./Features";

import styles from "./Intro.module.scss";

function Intro({ id, className, showAmenities, onLoad }) {
  const {
    featureFlags: {
      csatRatingEnabled,
      brandSegmentBadgeEnabled,
      ancillariesAsUpgrades,
    },
  } = useBootstrap();
  const {
    listing: {
      id: listingId,
      title,
      location,
      ratingAverage,
      ratingState,
      ratingTotal,
      shortDescription,
      topAmenities,
      brandSegment,
    },
    availableUpgrades,
    isAvailableUpgradesLoading,
  } = useContext(PropertyListingContext);

  useEffect(() => {
    onLoad?.();

    // can't add onLoad to deps array because it's re-initialized every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isAvailableUpgradesEmpty =
    !availableUpgrades.length && !isAvailableUpgradesLoading;

  const upgradesOrStandards = isAvailableUpgradesEmpty ? (
    <TopStandards standards={[]} />
  ) : (
    <TopUpgrades upgrades={availableUpgrades} onSeeAll={showAmenities} />
  );

  return (
    <Section id={id} className={classnames(styles.container, className)}>
      <Header type="headline2" className={styles.title_header}>
        {title}
      </Header>
      {csatRatingEnabled && (
        <Text
          types={["subtitle1"]}
          className={styles.rating_header}
          element="div"
        >
          <Rating
            average={ratingAverage}
            listingId={listingId}
            state={ratingState}
            total={ratingTotal}
          />
        </Text>
      )}
      <Text types={["subtitle1"]} className={styles.location_header}>
        {location}
      </Text>
      <Text types={["subtitle1", "pre_wrap"]} className={styles.description}>
        {shortDescription}
      </Text>
      <div className={styles.columnTwo}>
        {ancillariesAsUpgrades ? (
          <div className={styles.features_container}>
            <TopAmenities amenities={topAmenities} onSeeAll={showAmenities} />
            {upgradesOrStandards}
          </div>
        ) : (
          <Features amenities={topAmenities} showAmenities={showAmenities} />
        )}
        {brandSegmentBadgeEnabled && brandSegment && (
          <BrandSegmentBadge
            className={styles.brandSegment}
            brandSegment={brandSegment}
            descriptionType="plural"
          />
        )}
      </div>
    </Section>
  );
}

Intro.defaultProps = {
  seeAllLink: "",
  showAmenities: () => {},
};

export default Intro;
